'use strict';

import {registerValidator} from '../helpers';

var number = function (model, attribute, value) {
    if ((typeof value === 'number' && (value % 1) === 0)) {
        return false;
    } else {
        return "This field must be a number";
    }
};

registerValidator('number', number);

export default number;